import gql from 'graphql-tag'

const queryDeleteCustomAttribute = gql`
  query queryDeleteCustomAttribute(
    $delete_id: [Float!]!
    $object_type_id: Float!
    $job_type_id: Float
    $workspace_id: Float!
  ) {
    queryDeleteCustomAttribute(
      delete_id: $delete_id
      object_type_id: $object_type_id
      job_type_id: $job_type_id
      workspace_id: $workspace_id
    ) {
      count
      id
      name
    }
  }
`

export default queryDeleteCustomAttribute
